
import React from "react";
import { Loader } from "../../../Common/Loader";
import { FlexColumn, SushiModal } from "../../../Common/styles.common";
import ViewPDF from "../../../../../utils/ViewPDF";
import Breadcrumb from "components/shared/Breadcrumb/Breadcrumb";
import {
    DesktopPage,
    TitleRow as TopRow,
    TitleBlock,
    Title,
    Actions,
    ActionButton,
} from "components/core/Common/DesktopHelpers/DesktopHelpers";
import Cross from "sushiweb/Icons/all/Cross";
import ShowToast from "../../../Common/Toast";

// ─── Inline styles ────────────────────────────────────────────────────────────

const previewBodyStyle = {
    background: "#ffffff",
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    overflow: "auto",
    maxHeight: "75vh",
    width: "100%",
};

// ─── Component ────────────────────────────────────────────────────────────────

export default function PreviewReuploadedInvoiceDesktop({
    poId,
    purchaseOrderNumber,
    itemsLength,
    tonnage,
    pdfBlob,
    setPdfBlob,
    invoiceDetails,
    setShowFile,
    presignedUrl,
    documentPath,
    metadata,
    // state / handlers (lifted from the container)
    showLoader,
    openConfirmation,
    closeConfirmation,
    handleConfirmClick,
    showToast,
    errMsg,
    goToDDList,
}) {
    if (showLoader) {
        return <Loader />;
    }

    return (
        <DesktopPage>
            {/* ── Success confirmation modal ── */}
            <SushiModal visible={openConfirmation} isCentered>
                <FlexColumn className="align-items-center p-5">
                    <div
                        className="align-self-end"
                        onClick={closeConfirmation}
                        style={{ cursor: "pointer" }}
                    >
                        <Cross />
                    </div>
                    <img src="/logos/tick_logo.svg" height="80px" width="80px" alt="success" />
                    <span className="fs-22 fw-700 my-4">Invoice uploaded</span>
                    <span
                        className="fs-14 fw-500 text-red-500"
                        style={{ cursor: "pointer" }}
                        onClick={closeConfirmation}
                    >
                        Okay
                    </span>
                </FlexColumn>
            </SushiModal>

            {/* ── Toast ── */}
            {showToast && <ShowToast errorMsg={errMsg} />}

            {/* ── TopRow: breadcrumb + title + action bar ── */}
            <TopRow>
                <TitleBlock>
                    <Breadcrumb
                        items={[
                            { label: "Home" },
                            { label: "Direct Delivery", onClick: goToDDList },
                            { label: purchaseOrderNumber },
                            { label: "Preview Invoice" },
                        ]}
                    />
                    <Title>{purchaseOrderNumber}</Title>
                </TitleBlock>
                <Actions>
                    <ActionButton type="button" $primary onClick={handleConfirmClick}>
                        Click to confirm
                    </ActionButton>
                </Actions>
            </TopRow>

            {/* ── PDF preview ── */}
            <div style={previewBodyStyle}>
                <ViewPDF pdfBlob={pdfBlob} setPdfBlob={setPdfBlob} />
            </div>
        </DesktopPage>
    );
}
